var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.15,
    height: 31.15,
    viewBox: "0 0 31.15 31.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6320",
    "data-name": "Group 6320",
    transform: "translate(-235 -907)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 31.15,
    height: 31.15,
    rx: 15.575,
    transform: "translate(266.15 907) rotate(90)",
    fill: "#1f94a7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "facebook_2_",
    "data-name": "facebook (2)",
    transform: "translate(247.015 914.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M152.9,0h-1.59a3.423,3.423,0,0,0-2.622.866,3.648,3.648,0,0,0-.8,2.552V4.49a.513.513,0,0,1-.513.513h-.55a.513.513,0,0,0-.513.513V7.121a.513.513,0,0,0,.513.513h.55a.513.513,0,0,1,.513.513v6.609a.513.513,0,0,0,.513.513h2.134a.513.513,0,0,0,.513-.513V8.147a.513.513,0,0,1,.513-.513h1.078a.582.582,0,0,0,.567-.51l.17-1.612a.451.451,0,0,0-.459-.51h-1.356a.513.513,0,0,1-.513-.513v-.8a2.881,2.881,0,0,1,.028-.459.893.893,0,0,1,.125-.32.511.511,0,0,1,.315-.218,2.244,2.244,0,0,1,.579-.06h.8a.513.513,0,0,0,.513-.513V.513A.512.512,0,0,0,152.9,0Z",
    transform: "translate(-146.32)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFacebook);
export default __webpack_public_path__ + "static/media/blue-facebook.bf86b1ec68cd606fd523b3d2196a5711.svg";
export { ForwardRef as ReactComponent };